<script setup>
import Button from '@components/forms/Button.vue'

defineProps(['data'])
</script>

<template>
	<div class="relative grid-cols-3 gap-3 overflow-hidden rounded-xl bg-black md:grid">
		<div class="flex items-center justify-center rounded-xl bg-[#161A25]">
			<img class="aspect-video h-full w-full object-cover" :src="data.image" :alt="data.title" />
		</div>
		<div class="relative z-10 col-span-2 flex flex-col justify-between gap-5 px-5 py-8 text-white md:py-12">
			<h6>{{ data.title }}</h6>
			<Button class="primary solid hidden md:block" :to="data.cta_button_url">{{ data.cta_button_label }}</Button>
			<Button class="primary solid wide md:hidden" :to="data.cta_button_url">{{ data.cta_button_label }}</Button>
		</div>
		<img class="absolute -bottom-16 right-0 opacity-50 transition-opacity duration-300 md:bottom-0 xl:opacity-100" src="https://cdn.snkesports.com/events/images/elements/accents/shard-tl.svg" alt="Shard" />
	</div>
</template>
